import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
const defaultAvatar = '/images/profile_default.png';

const css = oxygenCss({
  root: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'inline-block',
    borderRadius: '50%',
    verticalAlign: 'middle'
  }
});

export default class ProfileImage extends Component {
  static propTypes = {
    author: PropTypes.object,
    size: PropTypes.number,
    style: PropTypes.object,
    className: PropTypes.string
  };

  static defaultProps = {
    author: '',
    size: 48,
    defaultAvatar: require('profile_default.png')
  };

  getStyle() {
    const avatarImage =
      this.props.author.avatar || this.props.author.avatarUrl || defaultAvatar;
    const { size, style } = this.props;
    return Object.assign({}, style, {
      backgroundImage: `url("${avatarImage}")`,
      width: size,
      height: size
    });
  }

  render() {
    const { className } = this.props;
    return (
      <div
        className={classNames(css.root, className)}
        style={this.getStyle()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/ProfileImage.js